export default "__VITE_ASSET__yi__MNyg__"